module.exports = __webpack_public_path__ + "e3bcd6199eb4de97c2a9735318eff9e7.pdf";